<script setup lang="ts">
import { ref, type HTMLAttributes } from 'vue'
import UiButton from '@/components/ui/button/Button.vue'
import MenuSvg from '@/assets/menu.svg'
import ShareFillSvg from '@/assets/icons/share-fill.svg'
import ExitSvg from '@/assets/exit.svg'
import CloseSvg from '@/assets/X.svg'
import StopSvg from '@/assets/icons/stop.svg'
import HumanSvg from '@/assets/icons/human.svg'
import StatsSvg from '@/assets/stats.svg'
import { cn } from '@/lib/utils'

import {
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuPortal,
  DropdownMenuRoot,
  DropdownMenuTrigger,
  DropdownMenuSeparator
} from 'radix-vue'

const props = defineProps<{
  isOwner?: boolean
  isSpectator?: boolean
  preConfiguredMode?: boolean
  playerStates?: string[]
  class?: HTMLAttributes['class']
}>()

const emit = defineEmits([
  'copy-link',
  'leave-table',
  'close-table',
  'sit-out',
  'session-log',
  'stand-up'
])

const isMenuVisible = ref(false)
</script>

<!-- TODO: Fix menu items value  -->
<template>
  <dropdown-menu-root v-model:open="isMenuVisible">
    <dropdown-menu-trigger :class="cn(props.class)" aria-label="Customise options">
      <ui-button size="icon" class="bg-menu-item-bg h-9 w-9 rounded-full" id="room-menu-button">
        <close-svg v-if="isMenuVisible" class="h-6 w-6" />
        <menu-svg v-else class="h-6 w-6" />
      </ui-button>
    </dropdown-menu-trigger>
    <dropdown-menu-portal>
      <dropdown-menu-content
        :sideOffset="8"
        :collisionPadding="{ top: 16, left: 16 }"
        class="z-[999] mr-4 rounded-xl bg-c1 p-2 outline-none transition-all will-change-[opacity,transform] data-[side=bottom]:animate-slideUpAndFade"
      >
        <div class="flex flex-col gap-[6px]">
          <dropdown-menu-item
            value="logout"
            class="flex cursor-pointer items-center gap-2 rounded-full bg-menuItemBg p-2 pr-3 text-white aria-disabled:pointer-events-none aria-disabled:opacity-50"
            @click="emit('sit-out')"
            :disabled="props.isSpectator || props.playerStates?.includes('sit_out')"
            v-if="!props.preConfiguredMode"
          >
            <stop-svg class="w-6" />
            <div>{{ $t('Compete.button.SitOut') }}</div>
          </dropdown-menu-item>
          <dropdown-menu-item
            value="logout"
            class="flex cursor-pointer items-center gap-2 rounded-full bg-menuItemBg p-2 pr-3 text-white aria-disabled:pointer-events-none aria-disabled:opacity-50"
            @click="emit('stand-up')"
            v-if="!props.preConfiguredMode"
            :disabled="props.isSpectator || !props.playerStates?.includes('sit_out')"
          >
            <human-svg class="w-6" />
            <div>{{ $t('Compete.button.StandUp') }}</div>
          </dropdown-menu-item>
          <dropdown-menu-separator v-if="!props.preConfiguredMode" class="my-1 h-px bg-divider" />

          <dropdown-menu-item
            value="logout"
            class="flex cursor-pointer items-center gap-2 rounded-full bg-menuItemBg p-2 pr-3 text-white aria-disabled:pointer-events-none aria-disabled:opacity-50"
            @click="emit('session-log')"
          >
            <stats-svg class="w-6" />
            <div>{{ $t('Compete.button.SessionLog') }}</div>
          </dropdown-menu-item>
          <dropdown-menu-item
            value="logout"
            class="flex cursor-pointer items-center gap-2 rounded-full bg-menuItemBg p-2 pr-3 text-white"
            @click="emit('copy-link')"
            v-if="!props.preConfiguredMode"
          >
            <share-fill-svg class="w-6" />
            <div>{{ $t('Compete.button.CopyLinkToTable') }}</div>
          </dropdown-menu-item>

          <dropdown-menu-separator class="my-1 h-px bg-divider" />
          <dropdown-menu-item
            id="leave-table-button"
            value="logout"
            class="flex cursor-pointer items-center gap-2 rounded-full bg-menuItemBg p-2 pr-3 text-white"
            @click="emit('leave-table')"
          >
            <exit-svg class="w-6" />
            <div>{{ $t('Compete.button.LeaveTable') }}</div>
          </dropdown-menu-item>
        </div>
      </dropdown-menu-content>
    </dropdown-menu-portal>
  </dropdown-menu-root>
</template>
